import { memo } from 'react';
import { Spin } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const ButtonPrimaryMedium = ({
  id,
  title,
  preIcon,
  posIcon,
  disabled,
  style,
  onClick,
  type = 'button',
  loading = false,
  ...props
}) => {
  return (
    <button
      type={type}
      id={id}
      disabled={disabled}
      style={{
        ...style,
        paddingLeft: preIcon ? '8px' : undefined,
        paddingRight: posIcon ? '8px' : undefined,
      }}
      className={cn(
        'inline-flex items-center min-w-0 max-w-full max-h-[32px] bg-primary-primary hover:bg-primary-primaryVarient1 disabled:bg-primary-primaryVarient2 disabled:text-white-medium',
        'h-[32px] py-[4px] px-[12px] gap-[6px] label-medium font-semibold rounded-[6px]',
        props.className,
        props.classNames?.root
      )}
      onClick={onClick}
    >
      {preIcon && (
        <div className="flex items-center justify-center w-[18px] h-[18px] text-white-high disabled:text-white-medium">
          {preIcon}
        </div>
      )}

      <span
        className={cn(
          'truncate text-white-high disabled:text-white-medium',
          props.classNames?.title
        )}
      >
        {title}
      </span>

      {loading && (
        <div className="flex items-center justify-center w-[18px] h-[18px]">
          <Spin
            size="small"
            className="[&_.ant-spin-dot-holder]:text-white-high"
          />
        </div>
      )}

      {posIcon && (
        <div className="flex items-center justify-center w-[18px] h-[18px] text-white-high disabled:text-white-medium">
          {posIcon}
        </div>
      )}
    </button>
  );
};

export default memo(ButtonPrimaryMedium);
